
import createIcon from "./createIcon";

export const FoldOutIcon = createIcon('FoldOut', (props) => {
  return (
    <svg {...props}>
      <g>
        <g>
          <path d="M0.6848554765625,0L14.0181884765625,0Q14.6848884765625,0,14.6848884765625,0.666667Q14.6848884765625,1.33333,14.0181884765625,1.33333L0.6848554765625,1.33333Q0.0181884169579,1.33333,0.0181884765625,0.666667Q0.0181884765625,-1.19209e-7,0.6848554765625,0Z" fill={props.color} fillOpacity="1" />
        </g>
        <g>
          <path d="M6.6848554765625,4L14.0181884765625,4Q14.6848584765625,4,14.6848584765625,4.666667Q14.6848584765625,5.33333,14.0181884765625,5.33333L6.6848554765625,5.33333Q6.0181884765625,5.33333,6.0181884765625,4.666667Q6.0181884765625,4,6.6848554765625,4Z" fill={props.color} fillOpacity="1" />
        </g>
        <g>
          <path d="M6.6848554765625,8L14.0181884765625,8Q14.6848584765625,8,14.6848584765625,8.666667Q14.6848584765625,9.33333,14.0181884765625,9.33333L6.6848554765625,9.33333Q6.0181884765625,9.33333,6.0181884765625,8.666667Q6.0181884765625,8,6.6848554765625,8Z" fill={props.color} fillOpacity="1" />
        </g>
        <g>
          <path d="M0.6848554765625,12L14.0181884765625,12Q14.6848884765625,12,14.6848884765625,12.666667Q14.6848884765625,13.33333,14.0181884765625,13.33333L0.6848554765625,13.33333Q0.0181884169579,13.33333,0.0181884765625,12.666667Q0.0181884765625,12,0.6848554765625,12Z" fill={props.color} fillOpacity="1" />
        </g>
        <g>
          <path d="M3.00801,4.128286C3.2921,3.920846,3.68847,3.9698195,3.91352,4.240165C4.13858,4.510511,4.11486,4.909195,3.85934,5.15095L3.79534,5.20429L1.79601,6.66629L3.79534,8.12829C4.06611,8.32662,4.14721,8.69531,3.98468,8.988949999999999L3.94001,9.059619999999999C3.74182,9.33098,3.37264,9.412410000000001,3.07868,9.24962L3.00801,9.20429L0.273344,7.20429C-0.0633364,6.95826,-0.0940594,6.46701,0.209344,6.18095L0.273344,6.12762L3.00801,4.127619L3.00801,4.128286Z" fill={props.color} fillOpacity="1" />
        </g>
      </g>
    </svg >
  )
});
